module.exports = __webpack_public_path__ + "sx.49243877f93c2bdefe6c.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sx.svg
// module chunks = styles